import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button } from "../../../BaseComponents";
import { MeasureToolbarWrap } from "./styles";
import { useMap } from "react-map-gl";
import { useMapboxDraw, MeasureMode } from "../../DrawToolProvider";
import { inputsActions } from "../../..";
import { Radio } from "antd";

const MeasureToolBar = () => {
  const { current: mapRef } = useMap();
  const map = mapRef.getMap();
  const draw = useMapboxDraw();

  const dispatch = useDispatch();

  const [measurement_type, set_measurement_type] = useState("meters");

  const toggleMeasurementUnitType = (e) => {
    set_measurement_type(e.target.value);
    MeasureMode.setUnit(e.target.value, map);
  };

  const cancel_measuring = () => {
    if (!draw || !map) return;

    if (map.getLayer("measure-text-layer")) {
      map.removeLayer("measure-text-layer");
    }

    if (map.getSource("measure-text-layer")) {
      map.removeSource("measure-text-layer");
    }

    const allFeatures = draw.getAll().features;
    const measureLines = allFeatures.filter((feature) => feature.properties.isMeasureLine);

    measureLines.forEach((line) => {
      draw.delete(line.id);
    });
    draw.changeMode("simple_select");
    dispatch(inputsActions.update_ui_state("is_measuring", false));
    map.getCanvas().style.cursor = "";

    MeasureMode.cleanup(map);
  };

  return (
    <MeasureToolbarWrap>
      <Radio.Group buttonStyle="solid" size="small" value={measurement_type} onChange={toggleMeasurementUnitType}>
        <Radio.Button key="feet" value="feet" className="offset-tool-button">
          ft
        </Radio.Button>
        <Radio.Button key="meter" value="meters" className="offset-tool-button">
          m
        </Radio.Button>
      </Radio.Group>
      <Button type="secondary" size="small" label="Deactivate" onClick={cancel_measuring} />
    </MeasureToolbarWrap>
  );
};

export { MeasureToolBar };
